export enum SessionTimeoutButtons {
  exitSession = 'exitSession',
  extendSession = 'extendSession',
  pastTimeout = 'pastTimeout',
}

export const modalTimeoutConfig = {
  panelClass: 'sessionTimeoutDialog',
  backdropClass: 'carm-dialog-backdrop',
};
